import '@/scss/styles.scss'
import $ from 'jquery';
import * as bootstrap from 'glib/bootstrap';
/** imagesLoaded图片是否加载判断组件 **/
import imagesLoaded from 'glib/imagesloaded/imagesloaded.pkgd.min'
/** 提示框 **/
import 'glib/messenger-hubspot/build/js/messenger.min.js';
import 'glib/messenger-hubspot/build/js/messenger-theme-flat.js';
/** 滚屏OwlCarousel2-2.3.4 **/
import "../plugin/OwlCarousel2-2.3.4/owl.carousel.js";
/** wow 页面模块划进动画，同aos **/
import WOW from 'wow.js/dist/wow.js';
/** aos 页面模块划进动画，同wow **/
import 'aos/dist/aos.css';
import AOS from 'aos/dist/aos';
/** textillate-master文字特效 **/
import "../plugin/textillate-master/assets/jquery.fittext.js";
import "../plugin/textillate-master/assets/jquery.lettering.js";
import "../plugin/textillate-master/jquery.textillate.js";
/** meanMenu响应式导航 **/
import '../plugin/meanMenu/meanmenu.min.js'

import "iscript/dist/arisu.window.min";


$(function() {
	if (window.jQuery && !jQuery.camelCase) {
		jQuery.camelCase = function(str) {
			return str.replace(/-([a-z])/g, function (_, letter) {
				return letter.toUpperCase();
			});
		};
	}
	if (!$.type) {
		$.type = function(obj) {
			return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
		};
	}

	//顶部导航栏载入
	$("#mn-header").load("load.html #header", function() {
		$(".navbar-nav > .nav-item:eq(0) > a").addClass("active");
		
		$(".mean-menu").meanmenu({
			meanScreenWidth: "991"
		});
		// $(window).on("scroll", function(e) {
		// 	if ($(e.currentTarget).scrollTop() > 150) {
		// 		$(".navbar-area").addClass("sticky-nav");
		// 	} else {
		// 		$(".navbar-area").removeClass("sticky-nav");
		// 	}
		// });
		
		//loading页面显示
		// $("body").addClass("ae-p7-loaded");
		$(".ae-preloader-12").fadeOut(700, function() {
			$(this).remove();
		});

		$("#mn-search-btn").click(function(){
			$(".mn-search").addClass("active");
		});



	});
	//底部页脚载入
	$("#mn-footer").load("load.html #footer");
	$("#mn-search-id").load("load.html #search", function() {
		$("#mn-search-close-btn").click(function(){
			$(".mn-search").removeClass("active");
		});
	});


	$("#carousel-image").owlCarousel({
		items: 1,
		loop:true,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		margin: 0,
		responsive: { 1024: { items: 1 }, 1500: { items: 1 }, 1900: { items: 1 } },
		navText: false,
		onInitialized: function() {
			// $(".ix-cd-1").textillate({
			// 	in: {effect: "animate__animated animate__fadeInLeftBig", sequence: false, sync: false, shuffle: false, reverse: true}
			// });
			// $(".ix-cd-2").textillate({in: {effect: "animate__animated animate__fadeInRightBig"}});
			// $(".ix-cd-3").textillate({in: {effect: "animate__animated animate__wobble"}});
			// $(".ix-cd-4").textillate({in: {effect: "animate__animated animate__fadeInUp"}});
			// $(".ix-cd-5").textillate({in: {effect: "animate__animated animate__fadeInDown"}});
		},
		onChanged: function(e) {
			//debug($( ".owl-item:eq(" + this.currentItem +")"));
			//alert($(".mn-cd-1", ".owl-item:eq(" + this.currentItem +")").html());
			//$(".ix-cd-1, .ix-cd-2, .ix-cd-3, .ix-cd-4, .ix-cd-5", ".owl-item:eq(" + this.currentItem +")").textillate("start");
			// $(".ix-cd-1, .ix-cd-2, .ix-cd-3, .ix-cd-4, .ix-cd-5", ".owl-item:eq(" + e.item.index +")").textillate("start");
		}
	});


	//返回顶部
	new arisu.u.GoTop('.ce-gotop', {
		position: {
			"bottom": '15px',
			"right": '15px'
		}
	});
	

})